import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col text-center mt-2" }
const _hoisted_5 = {
  key: 1,
  class: "row"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col text-center my-2" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" })
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "row"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col text-center my-2 text-danger" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Der opstod en fejl, prøv igen senere..")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 3,
  class: "row mb-2"
}
const _hoisted_12 = { class: "col-12 text-end" }
const _hoisted_13 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = { class: "row mb-5" }
const _hoisted_19 = {
  key: 0,
  class: "col-6 text-start"
}
const _hoisted_20 = {
  key: 1,
  class: "col-6 text-end"
}
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_StepProgess = _resolveComponent("StepProgess")!
  const _component_LoadAddress = _resolveComponent("LoadAddress")!
  const _component_LoadJobInfo = _resolveComponent("LoadJobInfo")!
  const _component_Fields = _resolveComponent("Fields")!
  const _component_Summary = _resolveComponent("Summary")!
  const _component_Saved = _resolveComponent("Saved")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.restoreDialog.display)
      ? (_openBlock(), _createBlock(_component_ConfirmDialog, {
          key: 0,
          text: _ctx.restoreDialog.text,
          title: _ctx.restoreDialog.title,
          enableX: _ctx.restoreDialog.enableX,
          okBtn: _ctx.restoreDialog.okBtn,
          cancelBtn: _ctx.restoreDialog.cancelBtn,
          onOk: _ctx.restoreDialog.ok,
          onCancel: _ctx.restoreDialog.cancel
        }, null, 8, ["text", "title", "enableX", "okBtn", "cancelBtn", "onOk", "onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_StepProgess, {
          steps: _ctx.createJob.steps,
          currentStep: _ctx.createJob.currentStep,
          maxStep: _ctx.createJob.maxStep,
          onStepClicked: _ctx.goToStep,
          disabled: _ctx.createJob.currentStep === _ctx.createJob.savedIndex
        }, null, 8, ["steps", "currentStep", "maxStep", "onStepClicked", "disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.createJob.getName(_ctx.createJob.currentStep)), 1)
      ])
    ]),
    (!_ctx.ready)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : _createCommentVNode("", true),
    (_ctx.ready && _ctx.errors)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      (_ctx.createJob.currentStep === _ctx.createJob.kundeOplysningerIndex)
        ? (_openBlock(), _createBlock(_component_LoadAddress, {
            key: 0,
            "onClick:loadCustomer": _cache[0] || (_cache[0] = x => _ctx.createJob.loadCustomer(x)),
            "onClick:loadContact": _cache[1] || (_cache[1] = x => _ctx.createJob.loadContact(x))
          }))
        : _createCommentVNode("", true),
      (_ctx.createJob.currentStep === _ctx.createJob.jobInfoIndex && _ctx.createJob.hasCustomer && !_ctx.createJob.hasContract)
        ? (_openBlock(), _createBlock(_component_LoadJobInfo, {
            key: 1,
            CustomerID: _ctx.createJob.customerId,
            "onClick:loadAddress": _cache[2] || (_cache[2] = x => _ctx.createJob.loadAddress(x))
          }, null, 8, ["CustomerID"]))
        : _createCommentVNode("", true),
      (_ctx.createJob.fields)
        ? (_openBlock(), _createBlock(_component_Fields, {
            key: 2,
            modelValue: _ctx.createJob.fields,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.createJob.fields) = $event)),
            "onUpdate:value": _ctx.fieldUpdated,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.action($event)))
          }, null, 8, ["modelValue", "onUpdate:value"]))
        : _createCommentVNode("", true),
      (_ctx.createJob.currentStep === _ctx.createJob.serviceopgaverIndex)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "btn btn-success",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addLine()))
              }, [
                _createTextVNode("Tilføj ny linje "),
                (!_ctx.createJob.ready)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !_ctx.errors && _ctx.ready && _ctx.createJob.hasFields &&  typeof _ctx.createJob.fields !== 'undefined']
    ]),
    (!_ctx.errors && _ctx.ready && _ctx.createJob.currentStep === _ctx.createJob.summeryIndex)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_Summary, { createJob: _ctx.createJob }, null, 8, ["createJob"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.errors && _ctx.ready && _ctx.createJob.currentStep === _ctx.createJob.savedIndex)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_Saved, {
            modelValue: _ctx.createJob.saved,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.createJob.saved) = $event)),
            onStartOver: _ctx.startOver
          }, null, 8, ["modelValue", "onStartOver"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      (_ctx.createJob.currentStep !== _ctx.createJob.savedIndex)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (_ctx.createJob.currentStep > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.previousStep()))
                }, _toDisplayString(_ctx.createJob.previousStepName), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.createJob.isLastStep)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              disabled: !_ctx.nextStepReady,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.nextStep()))
            }, _toDisplayString(_ctx.createJob.nextStepName), 9, _hoisted_21)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}